import * as React from 'react';
import { type FunctionComponent } from 'react';
import { styled, applyClassName } from '@glitz/react';
import nnLogoSvg from './logotype.svg';
import kitchenTimeLogoSvg from './logokitchtime.svg';
import lightShopLogoSvg from './logolightshop.svg';
import svenssonsLogoSvg from './logosvenssons.svg';
import svenssonsDesktopLogoSvg from './logosvenssonslarge.svg';
import { SiteTheme } from 'webapp/theme';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { useMatchLargeViewport } from '@avensia/excite';

const normalize = (c: FunctionComponent) =>
  styled(applyClassName(c), {
    display: 'block',
    height: '1em',
    width: '1em',
  });

export const NordicNestLogo = styled(normalize(nnLogoSvg), {
  width: 'auto',
  height: 32,
});

export const KitchenTimeLogo = styled(normalize(kitchenTimeLogoSvg), {
  width: 'auto',
  height: 14,
});

export const LightShopLogo = styled(normalize(lightShopLogoSvg), {
  width: 'auto',
  height: 32,
});

export const SvenssonsLogoSvg = styled(
  normalize(svenssonsLogoSvg),
  createMinLargeViewportDecorator({
    height: 42,
  }),
  {
    width: 'auto',
    height: 40,
  },
);

export const SvenssonsDesktopLogoSvg = styled(normalize(svenssonsDesktopLogoSvg), {
  width: 'auto',
  height: 48,
});

export function SiteLogo() {
  const isLargeViewport = useMatchLargeViewport();

  switch (__SITE__) {
    case SiteTheme.NordicNest:
      return <NordicNestLogo />;
    case SiteTheme.Kitchentime:
      return <KitchenTimeLogo />;
    case SiteTheme.Lightshop:
      return <LightShopLogo />;
    case SiteTheme.Svenssons:
      return isLargeViewport ? <SvenssonsDesktopLogoSvg /> : <SvenssonsLogoSvg />;
    default:
      return <NordicNestLogo />;
  }
}
